import React from "react";
import {
  Row,
  Input,
  Button,
  Table,
  Icon,
  Pagination,
  Skeleton,
  Spin,
} from "antd";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import { saveLastListUrl } from "../../utils/navOrigin";
import { formatDate } from "../../utils/dateUtils";
import {
  stringSorter,
  dateSorter,
} from "../../utils/sortUtils";
import CSVIconComponent from "../Icons/CSVIconComponent";
import XLSIconComponent from "../Icons/XLSIconComponent";

let self;

class AlarmsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "Cargando...",
      statusCode: 0,
      dataSource: [],
      count: 0,
      searchText: "",
      searchedColumn: "",
      editingKey: "",
      dataToShow: [],
      currentPage: 1,
      status: "loading",
      size: 10,
      paginatedSearch: false,
      mustShowTable: false,
    };
    self = this;
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 190, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reiniciar
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  }

  handleReset(clearFilters) {
    clearFilters();
    this.setState({
      searchText: "",
    });
  }

  handlePagChange = (page, size) => {
    const { dataSource } = this.state;
    const start = (page - 1) * size;
    const end = start + size;

    this.setState({
      currentPage: page,
      size,
      dataToShow: dataSource.slice(start, end),
    });
  };

  handlePagSizeChange = (current, size) => {
    const { dataSource } = this.state;
    const page = 1;
    const start = 0;
    const end = size;

    this.setState({
      currentPage: page,
      size,
      dataToShow: dataSource.slice(start, end),
    });
  };

  handleFetchAlarms = (page, size, isPaginating = false) => {
    const {
      startDateAlarm,
      endDateAlarm,
      tempAlarm,
      impactAlarm,
      openAlarm,
      humAlarm,
    } = this.props.searchParameters;

    this.setState({
      status: isPaginating ? "paginating" : "loading",
      mustShowTable: isPaginating ? true : false,
      statusCode: 0,
    });

    this.props.fetchAlarms(
      startDateAlarm,
      endDateAlarm,
      tempAlarm,
      impactAlarm,
      openAlarm,
      humAlarm,
      size,
      page,
      isPaginating,
    );
  };

  renderAlarms(record) {
    let alarm;

    if (record.alarmTemp) alarm = "Temperatura";
    if (record.alarmHum) alarm = "Humedad";
    if (record.alarmImpact) alarm = "Impacto";
    if (record.alarmOpen) alarm = "Apertura";

    return alarm;
  }

  renderShipmentCode(shipmentCode, from) {
    if (shipmentCode !== "N/D") {
      return (
        <Link
          to={{
            pathname: "/envio",
            search: `?shipmentCode=${shipmentCode}`,
            state: { from },
          }}
          onClick={() => saveLastListUrl(from)}
        >
          {shipmentCode}
        </Link>
      );
    }
    return shipmentCode;
  }

  handleExport = (fileType) => {
    if (this.props.onExport) {
      this.props.onExport(fileType);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.alarmsData !== this.props.alarmsData) {
      const { status, statusCode, data, totalResults } = this.props.alarmsData;

      if (statusCode === 0 && status === "paginating") {
        this.setState({ mustShowTable: true, status: "paginating" });
        return;
      }

      if (statusCode !== 200) {
        this.setState({
          message: this.props.alarmsData.message,
          status,
          statusCode,
          mustShowTable: false,
        });
        return;
      }

      if (this.props.alarmsData.statusCode === 200) {
        if (
          !this.props.alarmsData.data.length &&
          this.props.alarmsData.status === "loaded"
        ) {
          this.setState({
            statusCode: 204,
            status: "loaded",
            message:
              "No se han encontrado resultados para los criterios de búsqueda seleccionados.",
            mustShowTable: false,
          });
          return false;
        }

        const processedData = this.props.alarmsData.data.map((record) => ({
          ...record,
          alarmName: this.renderAlarms(record),
        }));

        const pageSize = this.state.size;
        const currentPage = 1;
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;

        this.setState({
          dataSource: processedData,
          dataToShow: processedData.slice(start, end),
          count: processedData.length,
          currentPage,
          size: pageSize,
          status: "loaded",
          statusCode: 200,
          mustShowTable: true,
        });
      }
    }
  }

  render() {
    const { dataToShow, count, status, statusCode, message, mustShowTable } =
      this.state;

    const { currentPage, size: pageSize } = this.state;

    const from = this.props.location.pathname + this.props.location.search;

    const tableColumns = [
      {
        title: "Código de bulto",
        dataIndex: "shipmentCode",
        sorter: stringSorter("shipmentCode"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("shipmentCode"),
        render: (shipmentCode) => (
          <span>{this.renderShipmentCode(shipmentCode, from)}</span>
        ),
      },
      {
        title: "IMEI",
        dataIndex: "imei",
        sorter: stringSorter("imei"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 85,
        align: "center",
        ...this.getColumnSearchProps("imei"),
      },
      {
        title: "Ref. cliente / pedido",
        dataIndex: "numRefClient",
        sorter: stringSorter("numRefClient"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 70,
        align: "center",
        ...this.getColumnSearchProps("numRefClient"),
      },
      {
        title: "Remitente",
        dataIndex: "senderName",
        sorter: stringSorter("senderName"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("senderName"),
      },
      {
        title: "Último evento",
        dataIndex: "eventName",
        sorter: stringSorter("eventName"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 80,
        align: "center",
        render: (eventName, row) => (
          <div
            style={{
              border: "1px solid #91D5FF",
              borderRadius: "4px",
              transform: "scale(0.8)",
              color: "#1990FF",
              background: "#E6F7FF",
              padding: ".2rem",
              minWidth: "100%",
              lineHeight: "1.3",
            }}
          >
            {!eventName ? "N/D" : eventName}
          </div>
        ),
      },
      {
        title: "Fecha y hora evento",
        dataIndex: "eventDate",
        sorter: dateSorter("eventDate"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 70,
        align: "center",
        render: (_, record) => {
          return <span>{formatDate(record.eventDate)}</span>;
        },
      },
      {
        title: "Ubicación del evento",
        dataIndex: "eventLocation",
        sorter: stringSorter("eventLocation"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 70,
        align: "center",
      },
      {
        title: "Destinatario",
        dataIndex: "destinationName",
        sorter: stringSorter("destinationName"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("destinationName"),
      },
      {
        title: "Alarma",
        dataIndex: "alarmName",
        sorter: stringSorter("alarmName"),
        editable: false,
        width: 90,
        align: "center",
      },
      {
        title: "Fecha y hora alarma",
        dataIndex: "alarmStartDate",
        sorter: dateSorter("alarmStartDate"),
        editable: false,
        width: 70,
        align: "center",
        render: (_, record) => {
          return <span>{formatDate(record.alarmStartDate)}</span>;
        },
      },
    ];

    const columns = tableColumns.map((col) => {
      return col;
    });

    const pagProps = {
      total: count,
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `${total} resultados`,
      hideOnSinglePage: false,
      current: currentPage,
      pageSize: pageSize,
      pageSizeOptions: ["10", "20", "40", "80"],
    };

    const paginationProps = {
      bordered: true,
      // rowSelection: {},
      rowClassName: () => "editable-row",
    };

    return (
      <div className="Alarmas">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <h2 style={{ margin: 0, lineHeight: 1 }}>Resultados</h2>

          {mustShowTable && (
            <div
              style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              className="tracks-table-scroll"
            >
              <Button
                type="default"
                onClick={() => this.handleExport("csv")}
                className="export-btn"
                disabled={status !== "loaded"}
              >
                <CSVIconComponent />
                Exportar CSV
              </Button>

              <Button
                type="default"
                onClick={() => this.handleExport("excel")}
                className="export-btn"
                disabled={status !== "loaded"}
              >
                <XLSIconComponent />
                Exportar Excel
              </Button>
            </div>
          )}
        </div>

        {status === "loading" && (
          <>
            <Skeleton active />
          </>
        )}

        {statusCode !== 200 && status === "loaded" && (
          <>
            <p>{message}</p>
          </>
        )}

        {mustShowTable && (
          <Spin
            tip="Cargando..."
            spinning={status === "paginating"}
            size="large"
            style={{ transform: "scale(2)" }}
          >
            <div className="tracks-table-scroll">
              <Table
                scroll={{ x: 500 }}
                {...paginationProps}
                dataSource={dataToShow}
                columns={columns}
                pagination={false}
              />
            </div>
            <Row
              type="flex"
              justify="end"
              style={{ marginTop: 16, background: "none", padding: 0 }}
            >
              <Pagination
                {...pagProps}
                onChange={this.handlePagChange}
                onShowSizeChange={this.handlePagSizeChange}
                style={{ background: "none" }}
              />
            </Row>
          </Spin>
        )}
      </div>
    );
  }
}

export default withRouter(withTranslation()(AlarmsTable));
